module.exports = __webpack_public_path__ + "media/images/docker-ed7146f08645fbd2c65f74af3e0c8bb0.png";